import { Link } from 'react-router-dom';
import { useCanAccessCustomerService } from '@/hooks/useCanAccessCustomerService';
import { Card, CardContent } from '@/components/ui/card';
import { 
  MessageSquare, 
  Phone, 
  Briefcase, 
  Users, 
  FileText,
  CheckSquare,
  Headphones
} from 'lucide-react';

interface QuickAccessItem {
  title: string;
  description: string;
  icon: React.ElementType;
  href: string;
  color: string;
}

const quickAccessItems: QuickAccessItem[] = [
  {
    title: 'WhatsApp',
    description: 'Mensagens',
    icon: MessageSquare,
    href: '/WhatsApp',
    color: 'text-green-600 bg-green-100 dark:bg-green-950',
  },
  {
    title: 'Tarefas',
    description: 'Agenda',
    icon: CheckSquare,
    href: '/agenda',
    color: 'text-purple-600 bg-purple-100 dark:bg-purple-950',
  },
  {
    title: 'Negociações',
    description: 'Pipeline de vendas',
    icon: Briefcase,
    href: '/Deals',
    color: 'text-orange-600 bg-orange-100 dark:bg-orange-950',
  },
  {
    title: 'Contatos',
    description: 'Clientes e leads',
    icon: Users,
    href: '/Contacts',
    color: 'text-pink-600 bg-pink-100 dark:bg-pink-950',
  },
  {
    title: 'Cases',
    description: 'Processos',
    icon: FileText,
    href: '/Cases',
    color: 'text-indigo-600 bg-indigo-100 dark:bg-indigo-950',
  },
  {
    title: 'Tarefas',
    description: 'To-do list',
    icon: CheckSquare,
    href: '/Tasks',
    color: 'text-amber-600 bg-amber-100 dark:bg-amber-950',
  },
  {
    title: 'Atendimento',
    description: 'Customer Service',
    icon: Headphones,
    href: '/customer-service',
    color: 'text-cyan-600 bg-cyan-100 dark:bg-cyan-950',
  },
];

export function QuickAccessGrid() {
  const { canAccess: canAccessCustomerService } = useCanAccessCustomerService();
  const items = quickAccessItems.filter(
    (item) => canAccessCustomerService || item.href !== '/customer-service'
  );

  return (
    <section>
      <div className="flex items-center gap-2 mb-4">
        <span className="text-lg">⚡</span>
        <h2 className="text-lg font-semibold text-foreground">Atalhos Rápidos</h2>
      </div>
      
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <Link key={item.href} to={item.href}>
              <Card className="h-full transition-all hover:shadow-md hover:scale-[1.02] cursor-pointer">
                <CardContent className="p-4 flex flex-col items-center text-center">
                  <div className={`p-3 rounded-xl ${item.color} mb-3`}>
                    <Icon className="h-6 w-6" />
                  </div>
                  <h3 className="font-medium text-foreground text-sm">
                    {item.title}
                  </h3>
                  <p className="text-xs text-muted-foreground mt-0.5">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
